import { Button, Modal } from 'react-bootstrap';
import { useState } from 'react';

const Availability = ({ type, headers, nepaliHeader, hallOneData, hallTwoData }) => {
    const [showModal, setShowModal] = useState(false);
    const [currentInquiries, setCurrentInquiries] = useState([]);

    const getStatusClass = (item) => {
        if (item.banquet) {
            const { paymentDetails, date } = item.banquet;
            const bills = paymentDetails?.billno;
            const remAmt = paymentDetails?.RemainingAmount || "0.00";

            if (bills != null && (remAmt === "0.00" || parseFloat(remAmt) < 0)) {
                return "paid";
            }
            if (typeof bills !== "string" && !date) {
                return "available";
            }
            if (typeof bills !== "string" && date) {
                return "unavailable";
            }
            if (typeof bills !== undefined && date) {
                return "payment";
            }
        }
        else if (item.inquiry) {
            return "inquiry";
        }

        return "available";
    };

    const openInquiryModal = (inquiries) => {
        setCurrentInquiries(inquiries);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const renderInquiries = (inquiries) => {
        if (!inquiries || inquiries.length === 0) return null;

        if (inquiries.length === 1) {
            return (
                <>
                    <span className="inquiry-label">Inquiry : </span>
                    {inquiries[0].customer_name}
                    <p className='pax-count'>
                        Contact: {inquiries[0].contact_no}
                    </p>
                </>
            );
        }

        const visibleInquiries = inquiries.slice(0, 3);
        const remainingCount = inquiries.length - 3;

        return (
            <div className="multiple-inquiries" onClick={() => openInquiryModal(inquiries)}>
                <span className="inquiry-label">Inquiries: </span>
                {visibleInquiries.map((inq, idx) => (
                    <span key={idx} className="inquiry-badge">
                        {inq.customer_name.substring(0, 1)}
                    </span>
                ))}
                {remainingCount > 0 && (
                    <span className="inquiry-more">... (+{remainingCount})</span>
                )}
            </div>
        );
    };

    const renderCellContent = (item) => {
        if (item.banquet) {
            const { customerName, paxCount, paymentDetails } = item.banquet;
            return (
                <>
                    {customerName}
                    {paymentDetails?.billno && (
                        <p className='pax-count'>
                            Bill No: <span>{paymentDetails?.billno}</span>
                        </p>
                    )}
                    <p className='pax-count'>
                        {item.banquet.date ? ((paymentDetails?.RemainingAmount <= 0) ? "PAX : " : "") : ""}
                        {(paymentDetails?.RemainingAmount <= 0) ? paxCount : ""}
                    </p>
                    {((paymentDetails?.RemainingAmount === "0.00" || parseFloat(paymentDetails?.RemainingAmount || "0.00") < 0) && paymentDetails?.billno != null ? "Balance Due: 0.00" : "")}
                    {(paymentDetails?.RemainingAmount && parseFloat(paymentDetails?.RemainingAmount) <= 0 ? "" : paymentDetails?.RemainingAmount)}
                </>
            );
        } else if (item.inquiry) {
            return renderInquiries(item.inquiry);
        }
        return null;
    };

    return (
        <div>
            <table className='table-availability'>
                <thead>
                    <tr>
                        <th className='headings'></th>
                        {nepaliHeader.map((date, index) => (
                            <th className='headings' key={index}>
                                {date.formattedDate}
                            </th>
                        ))}
                    </tr>
                    <tr>
                        <th className='headings'></th>
                        {headers.map((item, index) => (
                            <th className='headings' key={index}>
                                {item}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th className='headings'>Hall 1</th>
                        {hallOneData.map((item, index) => (
                            <td
                                className={getStatusClass(item)}
                                key={index}
                            >
                                {renderCellContent(item)}
                            </td>
                        ))}
                    </tr>
                    <tr>
                        <th className='headings'>Hall 2</th>
                        {hallTwoData.map((item, index) => (
                            <td
                                className={getStatusClass(item)}
                                key={index}
                            >
                                {renderCellContent(item)}
                            </td>
                        ))}
                    </tr>
                </tbody>
            </table>

            <Modal show={showModal} onHide={closeModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Inquiry Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="inquiry-list">
                        {currentInquiries.map((inq, idx) => (
                            <div key={idx} className="inquiry-item mb-3">
                                <h6>{inq.customer_name}</h6>
                                <p className="mb-1"><strong>Contact:</strong> {inq.contact_no}</p>
                                {inq.email && <p className="mb-1"><strong>Email:</strong> {inq.email}</p>}
                                {inq.about && <p className="mb-0"><strong>Notes:</strong> {inq.about}</p>}
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Availability;